import React from 'react';
import "./ProductCard.css";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ product }) => {
  const { title, brand, imageUrl, price, discountedPrice, color, discountPersent, active } = product;
  const navigate = useNavigate();
  const isInactive = active === false;

  const handleNavigate = () => {
    if (!isInactive) navigate(`/product/${product?.id || product?._id || 2}`);
  };

  return (
    <div
      onClick={handleNavigate}
      className={`productCard w-[18rem] border m-3 transition-all rounded-lg overflow-hidden relative ${
        isInactive ? 'cursor-not-allowed' : 'cursor-pointer'
      }`}
    >
      <div className="h-[22rem] bg-gray-50 flex items-center justify-center p-2 relative">
        <img
          className={`h-full w-full object-contain ${isInactive ? 'blur-sm' : ''}`}
          src={imageUrl}
          alt=""
        />
        {isInactive && (
          <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
            <span className="bg-gray-800 text-white text-xs font-bold px-3 py-1.5 rounded shadow-md uppercase tracking-wider">
              Not Available
            </span>
          </div>
        )}
      </div>
      <div className={`textPart bg-white p-3 ${isInactive ? 'opacity-50' : ''}`}>
        <div>
          <p className='font-bold opacity-60'>{brand}</p>
          <p className=''>{title}</p>
          <p className='font-semibold opacity-50'>{color}</p>
        </div>
        <div className='flex space-x-2 items-center'>
          <p className='font-semibold'>${typeof discountedPrice === 'number' ? discountedPrice.toFixed(2) : discountedPrice}</p>
          {discountPersent > 0 && (
            <>
              <p className='opacity-50 line-through'>${typeof price === 'number' ? price.toFixed(2) : price}</p>
              <p className='text-green-600 font-semibold'>{discountPersent}% off</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
